module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户姓名",
      "prop": "user_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请输入用户姓名"
    },
    model: {
      value: (_vm.form.user_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.user_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add('form')
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14010f96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/user/add.vue
// module id = 1805
// module chunks = 2